import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { WhyPerceptiBG } from "@/components/site/WhyPerceptiBG";
import { WHY_PERCEPTICA_DESCRIPTION_BG } from "@/content/meta/WhyPerceptiBG";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/bg/why-perceptica")({
  head: () => ({
    meta: [
      { title: "Защо Perceptica - мониторинг, MLP платформа и медиен анализ" },
      { name: "description", content: WHY_PERCEPTICA_DESCRIPTION_BG },
      { property: "og:title", content: "Защо Perceptica - мониторинг, MLP платформа и медиен анализ" },
      { property: "og:description", content: WHY_PERCEPTICA_DESCRIPTION_BG },

      ...ogImageMeta("bg", "/why-perceptica", "Защо Perceptica"),
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Защо Perceptica - мониторинг, MLP платформа и медиен анализ" },
      { name: "twitter:description", content: WHY_PERCEPTICA_DESCRIPTION_BG },
      { property: "og:url", content: "https://perceptica.com/bg/why-perceptica" },
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/why-perceptica" }),
  }),
  component: WhyPerceptiBG,
});
